// extracted by mini-css-extract-plugin
export default {"root":"PriceRecommendation__root--EJVps","title":"PriceRecommendation__title--hClSY","value":"PriceRecommendation__value--ToIAy"};